import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { SNACKBAR_STATUS } from "../../utils/constants";

function ShowSnackBar(props) {
  const { onClose, message, open, status, duration = 3000 } = props;
  const theme = useTheme();
  const onCloseSnack = () => onClose();

  const getStatus = () => {
    if (status === SNACKBAR_STATUS.SUCCESS)
      return {
        "& div": {
          background: theme.palette.success.dark,
        },
      };
    if (status === SNACKBAR_STATUS.WARNING)
      return {
        "& div": {
          background: theme.palette.warning.dark,
        },
      };
    return {
      "& div": {
        background: theme.palette.error.dark,
      },
    };
  };

  return (
    <Snackbar
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={onCloseSnack}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      autoHideDuration={duration}
      sx={getStatus()}
      message={message}
      open={open}
      onClose={onCloseSnack}
    />
  );
}

ShowSnackBar.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  duration: PropTypes.number,
};
ShowSnackBar.defaultProps = {
  duration: 3000,
};

export default ShowSnackBar;
